import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/box-plot/pages/CalculatorPage";

export const Route = createFileRoute("/box-plot")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/box-plot",
      title: m.box_meta_title(),
      description: m.box_meta_description(),
      toolName: m.box_tool_name(),
      faqs: [
        { q: m.box_faq_q1(), a: m.box_faq_a1() },
        { q: m.box_faq_q2(), a: m.box_faq_a2() },
        { q: m.box_faq_q3(), a: m.box_faq_a3() },
        { q: m.box_faq_q4(), a: m.box_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
